import {
  Box,
  Divider,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Stack,
  Toolbar,
  Typography,
} from "@mui/material";
import React from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { Imenu, systemMenu, newsMenu } from "./HomeMenu";
import { Icontext } from "./interface";
import { login, progress } from "./services/app.service";
import Logo from "./ui/logo";
import MyToolbar from "./widgets/MyToolbar";

export default function Home() {
  const [context, setContext] = React.useState<Icontext>({
    me: login.me
  });




  React.useEffect(() => {
    if (!localStorage.getItem("token")) {
      login.loginForm.next(true);
    }
    login.changed.subscribe((r) => {
      handleContext()
      login.loginForm.next(!login.me);
    });
    if (!login.changed.observed && !login.me) {
      login.getMe();
    }
    handleContext();
    // eslint-disable-next-line
  }, []);

  async function handleContext() {
    setContext({ me: login.me })
  }


  const locationArr = useLocation().pathname.split("/");
  const showSide = locationArr[2] !== "account";

  return context.me?._id ? (
    <Box>
      <MyToolbar context={context} />
      {showSide && <HomeSide context={context} />}
      <Stack sx={showSide ? { ml: "200px" } : {}}>
        <Toolbar />
        <Stack sx={{ mb: 10 }}>
          <Outlet context={[context, setContext]}></Outlet>
        </Stack>
      </Stack>
    </Box>
  ) : (
    <Stack
      sx={{
        height: "100vh",
        width: "100vw",
        justifyContent: "center",
        alignItems: "center",
        position: "absolute",
      }}
      onClick={() => {
        !progress.value && login.loginForm.next(true);
      }}>
      <Stack
        style={{ opacity: 0.2 }}
        flexGrow={1}
        alignItems="center"
        justifyContent="center">
        <Logo></Logo>
      </Stack>
      <Typography color="text.secondary" textAlign={"center"}>
        用户未登录
      </Typography>
    </Stack>
  );
}

//=============================================================={ HomeSide }
function HomeSide(props: { context: Icontext }): JSX.Element {
  const { context } = props;
  const locationArr = useLocation().pathname.split("/");
  const navigate = useNavigate();
  const [menu, setMenu] = React.useState<{
    news: Imenu[];
    sys: Imenu[];
  }>();

  React.useEffect(() => {
    setMenu({
      news: newsMenu, sys: context.me?.roles?.includes('超级管理员') ? systemMenu : []
    });
  }, [context]);

  return (
    <Stack
      sx={{
        width: 200,
        position: "fixed",
        height: "100vh",
        // backgroundColor: "#9e9e9e30",
      }}>
      <Toolbar />
      {menu && (
        <Stack sx={{ height: "100%", overflow: "auto" }}>
          {MyList(menu.news, navigate, locationArr, "新闻")}
          {MyList(menu.sys, navigate, locationArr, "系统")}
        </Stack>
      )}
    </Stack>
  );
}

function MyList(
  menu: Imenu[],
  navigate: any,
  locationArr: string[],
  caption: string
) {
  return (
    <React.Fragment>
      {!!menu.length && (
        <Stack>
          <Divider />
          <Typography variant="caption" sx={{ m: 1 }}>
            {caption}
          </Typography>
        </Stack>
      )}
      <List disablePadding={true} sx={{ mb: 1 }} >
        {menu.map((i, index) => (
          <React.Fragment key={index}>
            <ListItem

              disablePadding={true}
              onClick={() => {
                navigate(i.name);
              }}>
              <ListItemButton sx={{ borderRadius: '2rem' }} selected={locationArr[2] === i.name}>
                {i.icon && (
                  <ListItemIcon sx={{ minWidth: 46 }}>
                    {locationArr[2] === i.name
                      ? React.cloneElement(i.icon, { color: "primary" })
                      : i.icon}
                  </ListItemIcon>
                )}
                <ListItemText primary={i.title} />
              </ListItemButton>
            </ListItem>
            {i.children && locationArr[2] === i.name && (
              <List sx={{ pl: 2, '.MuiButtonBase-root, li': { borderRadius: '2rem' } }}>
                {i.children.map((ii, iindex) => {
                  const _selected = (locationArr[3] || "") === ii.name;
                  return (
                    <ListItem
                      key={iindex}
                      disablePadding={true}
                      sx={
                        _selected
                          ? {
                            bgcolor: (theme) => theme.palette.action.hover,
                            // borderLeftWidth: 10,
                            // borderLeftStyle: "solid",
                            // bgcolor: "action.disabledBackground",
                            borderLeftColor: (e) => {
                              return e.palette.primary.main;
                            },
                          }
                          : {}
                      }
                      onClick={() => {
                        navigate([i.name, ii.name].join("/"));
                      }}>
                      <ListItemButton>
                        {/* <ListItemIcon sx={{ minWidth: "2.5rem", ml: "1rem" }}>
                          {_selected && ii.icon
                            ? React.cloneElement(ii.icon, { color: "primary" })
                            : ii.icon}
                        </ListItemIcon> */}
                        <ListItemText
                          primaryTypographyProps={
                            _selected ? { color: "primary" } : {}
                          }
                          primary={ii.title}
                        />
                      </ListItemButton>
                    </ListItem>
                  );
                })}
              </List>
            )}
          </React.Fragment>
        ))}
      </List>
    </React.Fragment>
  );
}
